import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=a2dbac30&"
import script from "./Accept.vue?vue&type=script&lang=ts&"
export * from "./Accept.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports